import { render, staticRenderFns } from "./IrrigatorProfileAllEventsList.vue?vue&type=template&id=7229dac7&"
import script from "./IrrigatorProfileAllEventsList.vue?vue&type=script&lang=js&"
export * from "./IrrigatorProfileAllEventsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports